import React, { FC } from 'react';
import { Card } from '@material-ui/core';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

import { IContentLayoutProps } from 'types/app';
import { useContent } from 'hooks';
import { IPostRenderProps } from 'features/posting';

import { getPhoto } from '../helpers';
import { ContentActions, User } from '../partials';
import { Important, Photo } from '../widgets';

interface IPropsEnhanced extends IContentLayoutProps, IPostRenderProps, WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(3),
    },
  });

const Manual: FC<IPropsEnhanced> = ({ classes, selectedGroup, toggleState }) => {
  const content = useContent();
  const photo = getPhoto(content);

  return (
    <Card className={classes.root}>
      <Important />
      <User selectedGroup={selectedGroup} toggleState={toggleState} />
      {!!photo && <Photo photo={photo} />}
      <ContentActions selectedGroup={selectedGroup} toggleState={toggleState} />
    </Card>
  );
};

export default withStyles(styles)(Manual);
